// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"CisionModule_textWrapper__yf9Ec","iframe":"CisionModule_iframe__db_ye"};